import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'reactstrap';
import { ArrowLeft, ArrowRight } from 'react-feather';
import NiceModal from '@ebay/nice-modal-react';
import { Flex } from '@chakra-ui/react';
import { useFormik } from 'formik';

import { ConfirmationButton } from '../Button';
import SelectInput from '../SelectInput';
import { BiometricContext } from '../../utility/context/Biometric';
import { ReactComponent as IconAceptar } from '../../assets/images/icons/ico_aceptar_green.svg';
import { PoppinsSemiBold } from '../Fonts';
import Hands from '../Icons/Hands';

import { validationSchema } from './Model';
import ModalHuellas from './ModalHuellas';
// import ModalHuellas from './ResultadoHuellas';
import { HandTitle } from './Misc';
import { useCaptureBiometrics, useHandsHandler } from './hooks';
import { toast } from 'react-toastify';

// NiceModal.register('modal-biometrics-preview', PreviewBiometrics);
NiceModal.register('modal-biometrics-preview', ModalHuellas);

const BiometricComponent = ({ initialDedos }) => {
	const [disabled, setDisabled] = useState(true);
	const [options, setOptions] = useState([]);
	// biometric hooks
	const { biometricos, newMessage, setBiometricsState } =
		useContext(BiometricContext);
	const { izquierda, derecha, onClickDedo, setHandsState } =
		useHandsHandler(initialDedos);
	const { iniciarQueueCaptura, queue, captured, finishedCapture } =
		useCaptureBiometrics();

	const formik = useFormik({
		initialValues: { biometric_id: null, biometric_type: null, dedos: null },
		validationSchema,
		enableReinitialize: true,
		onSubmit: async ({ biometric_id, biometric_type, dedos }) => {
			setHandsState(1, dedos);
			iniciarQueueCaptura(dedos, biometric_type, biometric_id);
		}
	});
	const onPreSubmit = async (e) => {
		const dedos_izquierda = Object.keys(izquierda)
			.filter((dedo) => !!izquierda[dedo])
			.map((key) => ({ mano_id: 'izquierda', dedo_id: key }));
		const dedos_derecha = Object.keys(derecha)
			.filter((dedo) => !!derecha[dedo])
			.map((key) => ({ mano_id: 'derecha', dedo_id: key }));
		const value = [...dedos_izquierda, ...dedos_derecha];
		await formik.setFieldValue('dedos', value.length ? value : null);
		formik.handleSubmit(e);
	};

	// on biometric changes
	useEffect(() => {
		if (biometricos.length) {
			const uniqueBiometricos = biometricos.filter(
				(value, index, self) =>
					self.findIndex(({ modelo }) => modelo === value.modelo) === index
			);
			const parsedOptions = uniqueBiometricos.map((b) => ({
				label: b.modelo,
				value: b.id
			}));
			setOptions(parsedOptions);
			if (parsedOptions.length) {
				formik.setFieldValue('biometric_type', biometricos.find((b) => b.id === parsedOptions[0].value)?.tipo);
				formik.setFieldValue('biometric_id', parsedOptions[0].value);
			}
		}
	}, [biometricos]);

	useEffect(() => {
		if (!queue?.length) {
			setDisabled(false);
		} else {
			const first = queue[0];
			console.log(
				first.biometric_type === 1
					? [first]
					: queue.filter((el) => el.type === first.type)
			);
			setHandsState(
				2,
				first.biometric_type === 1
					? [first]
					: queue.filter((el) => el.type === first.type)
			);
			setDisabled(true);
		}
	}, [queue]);

	useEffect(() => {
		if (captured?.length) {
			setHandsState(3, captured);
		}
	}, [captured]);

	const showResultsModal = async (biometric_id, initialCaptured) => {
		return await NiceModal.show('modal-biometrics-preview', {
			biometric_id,
			initialCaptured
		});
	};
	useEffect(() => {
		if (finishedCapture) {
			toast.success('CAPTURA COMPLETADA CON ÉXITO', {
				position: 'bottom-right',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				theme: 'colored'
			});
			const biometric_id = formik.values.biometric_id;
			showResultsModal(biometric_id, captured).then((response) => {
				setBiometricsState(response);
			});
		}
	}, [finishedCapture]);

	return (
		<Form
			onSubmit={(e) => {
				e.preventDefault();
				formik.handleSubmit(e);
			}}
			style={{ flexDirection: 'column', gap: 20, width: '100%' }}
		>
			<Flex flexDirection="column" alignItems="center" justifyContent="center">
				{biometricos.length &&
				newMessage?.type !== 'biometrico_desconectado' ? (
					<PoppinsSemiBold
						as="span"
						color="#2E353A"
						sx="16px"
						textAlign="center"
						height="32px"
					>
						Biométrico conectado <IconAceptar />
					</PoppinsSemiBold>
				) : (
					<PoppinsSemiBold
						as="span"
						color="#2E353A"
						sx="16px"
						textAlign="center"
						height="32px"
					>
						Biométrico desconectado
					</PoppinsSemiBold>
				)}
				<Flex
					marginY="1.5rem"
					alignItems="flex-start"
					justifyContent="center"
					width="100%"
					gap={20}
				>
					<SelectInput
						name="biometric_id"
						onChange={({ value }) => {
							formik.setFieldValue(
								'biometric_type',
								biometricos.find((b) => b.id === value)?.tipo
							);
							formik.setFieldValue('biometric_id', value);
						}}
						errors={formik.touched?.biometric_id && formik.errors?.biometric_id}
						style={{ width: '260px', marginBottom: '0' }}
						options={options}
						disabled={disabled}
						value={formik.values['biometric_id']}
					/>
					<ConfirmationButton
						label={disabled ? 'Capturando' : 'Capturar'}
						onClick={onPreSubmit}
						disabled={disabled}
					/>
				</Flex>
			</Flex>
			{/* MANOS */}
			<Flex flexDirection="column" height="400px" justifyContent="center">
				<Flex
					position="relative"
					marginBottom="20px"
					alignItems="center"
					justifyContent="space-around"
				>
					<HandTitle>
						<ArrowLeft color="green" /> Mano Izquierda
					</HandTitle>
					<HandTitle>
						Mano Derecha <ArrowRight color="green" />
					</HandTitle>
				</Flex>
				<Flex
					position="relative"
					marginBottom="20px"
					wrap="wrap"
					alignItems="flex-end"
					justifyContent="space-around"
				>
					<Hands
						type_biometric={
							biometricos.find((b) => b.id === formik.values.biometric_id)?.tipo
						}
						onClickDedo={onClickDedo}
						manos={{ derecha, izquierda }}
						disabled={disabled}
					/>
				</Flex>

				<PoppinsSemiBold
					color="red"
					sx="13px"
					textAlign="center"
					position="absolute"
					width="100%"
					bottom="0"
				>
					{formik.touched?.dedos && formik.errors?.dedos}
				</PoppinsSemiBold>
			</Flex>
		</Form>
	);
};

export default BiometricComponent;
